import AppSettings from "../config";
import { QueryResult } from "react-query";

export interface Product {
  id: string;
  type: "product";
  attributes: {
    name: string;
    description: string | null;
    abbreviation: string | null;
    category: "product" | "integration";
    sellable: boolean;
    entitlements: string[];
  };
}

export const hasProduct = (queryResult: QueryResult<{ data: Product[] }>, productName: string) => {
  const products = queryResult.data?.data ?? [];
  return !!products.find((product) => product.attributes.name === productName);
};

export const fetchGetProducts = (headers: any) => (key: any, site: string) => {
  return fetch(`${AppSettings.PRODUCTS_API_URL}/sites/${site}/products`, {
    method: "GET",
    headers,
  }).then((response) => {
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  });
};
